import { Breadcrumb, Container } from "react-bootstrap";
import clsx from "classnames";
import classes from "./styles.module.scss";
import PropTypes from "prop-types";
import { getRoute } from "@/functions/getRoute";

export default function BreadcrumbNavigation({ className, items }) {
  return (
    <div className={clsx(className, classes.breadcrumbs)}>
      <Container className="mw-xxl">
        <Breadcrumb>
          <Breadcrumb.Item href={getRoute("home")}>Home</Breadcrumb.Item>
          {items.map(({ label, href }, k) => (
            <Breadcrumb.Item key={k} href={href}>
              <svg width="6" height="8" viewBox="0 0 6 8" fill="#F25A18" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 4L0 -2.62268e-07L-3.49691e-07 8L6 4Z" />
              </svg>
              {label}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
      </Container>
    </div>
  );
}

BreadcrumbNavigation.defaultProps = {
  className: "",
  items: [],
};

BreadcrumbNavigation.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      href: PropTypes.string,
    }),
  ),
};
